// Cliente del gateway `/gateway/sucursales/location`. Backend distinto del
// turnero (otro contrato, otro flujo), asi que la instance vive aparte para
// que futuros interceptors (auth, retry, headers) queden scoped por dominio.
import Axios from 'axios';
import { attachErrorInterceptor } from './errorInterceptor';

const baseURL =
  process.env.REACT_APP_SUCURSALES_API_URL_PATH || '/gateway/sucursales/location';

export const sucursalesAxios = Axios.create({
  baseURL,
});

// El gateway no expone (aun) una marca de "user-friendly": no hay campo
// `solucionable` ni un `exceptionMessage` documentado. Hasta que exista
// esa convencion, todos los errores caen al fallback generico — asi
// evitamos leakear textos tecnicos o HTML del gateway a la UI.
attachErrorInterceptor(sucursalesAxios, () => false);
